/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider, FormControlLabel, Checkbox, makeStyles } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import AutoForm from "../form/functional/AutoForm";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { debounce } from 'lodash';
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";

const useStyles = makeStyles((theme) => ({

    keepOpenSwitch: {
        marginLeft: "8px"
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },

}));


function TkProcessTempleteDialog ( props ) {

    const {

        id,
        schema,
        
        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,
        mode,
        title,
        formId,
        initialData,
        onSelect,

        ...others

    } = props;

    const classes = useStyles ();

    const { t } = useTranslation ();

    const [instance, setInstance] = useState ();
    const [formData, setFormData] = useState({});
    const [keepOpen, setKeepOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [ grid, setGrid] = useState();
    const [interaction, setInteraction] = useState(mode ? false : true);

    useEffect(()=>{

        if(initialData) {
            setFormData({...initialData})
        }

    },[initialData])


    const checkItemValidataion = ( schema, formData ) => {

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                nofifyWarning ( msg );
                return false;

            }
            
        }

        return true;

    }

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );


    };

    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {
        
        setKeepOpen ( ( keepOpen ) => {

            if ( !keepOpen ) {

                instance.hide();

            }

            if  ( onSuccess ) {

                setTimeout ( ( ) =>  onSuccess ( result.data.text ), 0 );
    
            } else {

                onNotifySuccess ( result.data.text );

            }

            return keepOpen;

        } );


    };

    const onApiFailure = (reason) => {

        notifyFailure ( t ( "error.insertFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

    };

    const onOk = ( schema, formData ) => {
        
        if ( ! checkItemValidataion ( schema, formData ) ) {
            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        const processList = [];
        for(let row of grid.rows) {
            processList.push(row.dataItem);
        }
        // build base api url

        let url = `/api/${schema.name}`;
        let apiData = { ...formData, processList };
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( apiData[formItem] !== undefined ) {

                json[formItem] = apiData[formItem];

            }
        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );
        
        switch(mode) {

            case "create" :

                apiClient
                    .post(url, form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((result) => onApiSuccess(result))
                    .catch((reason) => onApiFailure(reason));

            break;

            default :

                apiClient
                    .put(url, form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((result) => onApiSuccess(result, schema))
                    .catch((reason) => onApiFailure(reason));

            break;
        }
    }

    const onCancel = () => {

        instance.hide();

    };

    const onModifyViewSchema = (schema) => {

        if (schema) {

            for (const column of schema.columns) {

                switch (column.name) {

                    case "processSelectionCheck":

                        column.onChange = (ctx, check) => {
                            setGrid((grid) => {
                                if (grid) {
                                    ctx.item.processSelectionCheck = check;
                                    setInteraction(true);
                                    grid.refresh(false);
                                }
                                return grid;
                            })
                        };

                        break;

                    default:

                        break;

                }
            }
        }
    };

    const onChange = ( formData ) => {
        
        setFormData((prevFormData)=> {
            let newFormData = {
                ...prevFormData,
                ...formData,

            };

            return newFormData;
        })
        setInteraction(true);

    }

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        if ( onClose ) {

            onClose ();

        }

        setFormData({});
    }

    const onGridInitialized = ( grid ) => {

        grid.selectionMode = "None";
        grid.allowSorting = "None";
        
        setGrid(grid);

    };

    const checkKeepOpen = () => {

        if(mode === "edit") {

            return <></>
        }else {

            return (
                <>
                    <FormControlLabel
                        control={

                            <Checkbox
                                className={classes.keepOpenSwitch}
                                checked={keepOpen}
                                color="primary"
                                onChange={ ()=> setKeepOpen( ( keepOpen ) => ( !keepOpen ) ) }
                                name="checkKeepOpen"
                                size="small"
                            />
                        }
                        label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                    />
                    <div style={{flexGrow: 1}}></div>
                </>
            )
        }
    }

    const onModifyUrl = (url) => {

        let newUrl;

        switch(mode) {

            case "edit" :

                if ( onSelect ) {
                    newUrl = url + "/" + onSelect.templeteId;
        
                } else {
        
                    newUrl = url + "/undefined";
                }
            break;

            default :

                newUrl = url;

            break;
        }
        

        return newUrl;
        
    };

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="sm"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeaderWithClose>
                <DialogTitle>
                    { title }
                </DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{padding: "0px", height: "600px"}}>

                <ReflexContainer orientation="horizontal">

                    <ReflexElement flex={0.20} >

                        <div
                            style={{
                                padding: "16px",
                            }}                    
                        >
                            <AutoForm
                                id="order-buyer-detail-create-form"
                                schema={schema}
                                mode={mode}
                                initialData={initialData}
                                onChange={onChange}
                            />

                        </div>

                    </ReflexElement>
                    <ReflexSplitter
                        style={{height: "1px",color:"lightgray"}}
                    />
                    <ReflexElement flex={0.80} >
                        <BasicCrudScreenType
                            id="TkVwProcessSelection"
                            view="TkVwProcessSelection"
                            noCreate
                            noEdit
                            noDelete
                            noExcel
                            noFilter
                            noSearch
                            noPagination
                            onInitialized={onGridInitialized}
                            onModifyViewSchema={onModifyViewSchema}
                            onModifyViewUrl = {onModifyUrl}
                        />
                    
                    </ReflexElement>

                </ReflexContainer>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />
            <DialogActionsOkCancel
                firstActionComponent={checkKeepOpen}
                labels={[ t("common.ok")]}
                buttonDisabled={[mode === "create" ? false : !interaction , false]}
                onOk={() => onOk(schema, formData)}
                onCancel={onCancel}
            />
        </Dialog>

    );

}

export default TkProcessTempleteDialog;
